// extracted by mini-css-extract-plugin
export default {"roles":"Roles_roles__oa-hg","permissions_table":"Roles_permissions_table__Tw136"};